module.exports = __webpack_public_path__ + "media/images/breadcrumb/breadcrumb-ef1fd2e4fc57d832836376dc96a1344a.png";